export const OVERVIEW = 'OVERVIEW';
export const STRENGTH = 'STRENGTH';
